const normalizeUserId = (userId: unknown) => {
  if (typeof userId !== "string") {
    return null;
  }

  const trimmedUserId = userId.trim();
  return trimmedUserId.length > 0 ? trimmedUserId : null;
};

export const resolveSelfSpeakingUserId = (selfUserId: string | null) =>
  normalizeUserId(selfUserId);

export const resolveRemoteSpeakingUserId = (participant: unknown) => {
  const customParticipantId =
    typeof participant === "object" &&
    participant !== null &&
    "customParticipantId" in participant
      ? (participant as { customParticipantId?: unknown }).customParticipantId
      : undefined;

  return normalizeUserId(customParticipantId);
};

export const resolveParticipantUserId = (participant: unknown) =>
  resolveRemoteSpeakingUserId(participant);
